import { render, staticRenderFns } from "./speed15-chart.vue?vue&type=template&id=b97a7ec0&scoped=true"
import script from "./speed15-chart.vue?vue&type=script&lang=js"
export * from "./speed15-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97a7ec0",
  null
  
)

export default component.exports